import { useUser } from "@saleor/auth";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import { PermissionEnum } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import { OrderConfirmUrlQueryParams } from "@saleor/OrderConfirm/urls";
import OrderConfirmViewAdmin from "@saleor/OrderConfirm/views/OrderConfirmViewAdmin";
import OrderConfirmViewCustomer from "@saleor/OrderConfirm/views/OrderConfirmViewCustomer";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  () => ({
    pageHeader: {
      marginBottom: "1.2rem",
      "& > :first-child": {
        margin: 0,
        marginBottom: "1.2rem"
      },
      "& > :nth-child(2)": {
        alignSelf: "flex-end"
      }
    }
  }),
  { name: "OrderConfirmView" }
);

export interface IOrderConfirmProps {
  params: OrderConfirmUrlQueryParams;
}

const OrderConfirmView: React.FC<IOrderConfirmProps> = ({ params }) => {
  const intl = useIntl();
  const classes = useStyles();

  const { user } = useUser();

  const isCustomer = useMemo(
    () =>
      !!user?.userPermissions.find(
        e => e.code === PermissionEnum.ALL_REPORT_CUSTOMER
      ),
    [user?.userPermissions]
  );

  return (
    <>
      <Container>
        <PageHeader
          className={classes.pageHeader}
          title={intl.formatMessage({
            defaultMessage: "Inquiry - Order Confirmation"
          })}
        />
        {isCustomer && !user.isSuperuser ? (
          <OrderConfirmViewCustomer params={params} />
        ) : (
          <OrderConfirmViewAdmin params={params} />
        )}
      </Container>
    </>
  );
};

export default OrderConfirmView;
